import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import createGlobalFilterSlice, { type GlobalFilterSliceState } from './slices/globalFilter';

const useGlobalFilterStore = create<GlobalFilterSliceState>()(
  persist(createGlobalFilterSlice, {
    name: 'userPreferencesStates',
    storage: createJSONStorage(() => localStorage),
    partialize: (state) => ({ vehicleGroupIds: state.vehicleGroupIds, filteredGroups: state.filteredGroups }),
  })
);

export default useGlobalFilterStore;
